// В.2.g / В.2.h-rebalance: Генетик Лиза (liv_genetik_liza, Герой Лив Лайф, 1/0/16).
// Пассивка: «Все воскрешённые юниты получают +1/1/0 до конца боя» (atk нерфлен с +2 до +1).
//
// Реализация: post-resurrect-хук. Когда resurrectUnit успешно завершён,
// проверяем — есть ли на стороне воскрешения живая Лиза БЕЗ Молчания.
// Если есть — applyPermanentBuff(card, +2/1/0).
//
// Сторона воскрешения = ownerIdx, который resurrectUnit передал в хук.
// Если на этой стороне Лиза-Герой — она баффает. Это значит, что Лиза-Герой
// бота тоже даёт буфф воскрешённым на стороне бота (Феникс может
// воскресить юнит на вражеской стороне — там Лиза-врага его и баффает).
//
// Лиза должна быть жива и не под Молчанием. Молчание отключает пассивку:
// новые воскрешения не баффаются; старые баффы остаются (стандарт).

import { registerPostResurrectHook } from './resurrect.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { applyPermanentBuff } from '../../buffs.js';

export const HERO_ID = 'liv_genetik_liza';
const LABEL = 'Лиза';
const SOURCE_ID = 'liv_genetik_liza_passive';

registerImplementedAbility(HERO_ID, 'passive');

registerPostResurrectHook((state, card, ownerIdx) => {
  const owner = state.players?.[ownerIdx];
  if (!owner?.hero) return;
  if (owner.hero.id !== HERO_ID) return;
  if (owner.hero.hp <= 0) return;
  if (owner.hero.current?.silenced) return;
  if (owner.hero.silenceSources && owner.hero.silenceSources.size > 0) return;
  applyPermanentBuff(state, card, { atk: 1, armor: 1, hp: 0 }, SOURCE_ID, LABEL);
  state.log?.add(`🧬 ${LABEL} [${owner.name}]: воскрешённому ${card.name_ru} +1/1/0`);
});
